import { apiAction } from "../models/requests";

const appendTokenName = (data) => {
    return data;
};

export function getGroups(){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    appendTokenName(data);
    return apiAction({
        types: ["GET_GROUPS_REQUESTED", "GET_GROUPS_SUCCESS", "GET_GROUPS_FAILED"],
        method: "POST",
        path: "admin/get_groups",
        body: data
    });
}

export function updateGroups(userData){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = userData;
    appendTokenName(data);
    return apiAction({
        types: ["UPDATE_GROUPS_REQUESTED", "UPDATE_GROUPS_SUCCESS", "UPDATE_GROUPS_FAILED"],
        method: "POST",
        path: "admin/update_group",
        body: data
    });
}

export function setGroupUserPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_GROUP_USER_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function setGroupSettingPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_GROUP_SETTING_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function setGroupImagePageInfo({pageSize,pageNo}){
    return {
        type : 'SET_GROUP_IMAGE_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}


export function getUsersGroup(groupId) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = {"group_id": groupId };
    appendTokenName(data);
    return apiAction({
        types: ["GET_USERSIN_GROUP_REQUESTED", "GET_USERSIN_GROUP_SUCCESS", "GET_USERSIN_GROUP_FAILED"],
        method: "POST",
        path: "admin/get_users_group",
        body: data
    });
}

export function createGroup(userData){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = userData;   
    appendTokenName(data); 
    return apiAction({
        types: ["CREATE_GROUP_REQUESTED", "CREATE_GROUP_SUCCESS", "CREATE_GROUP_FAILED"],
        method: "POST",
        path: "admin/create_group",
        body: data
    });
}

export function addUserToGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};   
    postData.target_user = {"user_id": data.userId};   
    appendTokenName(postData); 
    return apiAction({
        types: ["ADD_USER_TO_GROUP_REQUESTED", "ADD_USER_TO_GROUP_SUCCESS", "ADD_USER_TO_GROUP_FAILED"],
        method: "POST",
        path: "admin/add_user_group",
        body: postData
    });
}

export function setGroupPageInfo({pageSize,pageNo}){
    return {
        type : 'SET_GROUP_PAGEINFO',
        payload : {pageSize,pageNo }
    }
}

export function deleteUserFromGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};   
    postData.target_user = {"user_id": data.userId};   
    appendTokenName(postData); 
    return apiAction({
        types: ["DELETE_USER_FROM_GROUP_REQUESTED", "DELETE_USER_FROM_GROUP_SUCCESS", "DELETE_USER_FROM_GROUP_FAILED"],
        method: "POST",
        path: "admin/remove_user_group",
        body: postData
    });
}

export function deleteGroup(groupId, force) {
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = {"group_id": groupId};
    data.force = force;
    appendTokenName(data);
    return apiAction({
        types: ["DELETE_GROUP_REQUESTED", "DELETE_GROUP_SUCCESS", "DELETE_GROUP_FAILED"],
        method: "POST",
        path: "admin/delete_group",
        body: data
    });
}

export function getSettingsGroup(groupId){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = {"group_id": groupId};
    appendTokenName(data); 
    return apiAction({
        types: ["GET_SETTINGS_GROUPS_REQUESTED", "GET_SETTINGS_GROUPS_SUCCESS", "GET_SETTINGS_GROUPS_FAILED"],
        method: "POST",
        path: "admin/get_settings_group",
        body: data
    });
}

export function getSettingsId(groupId){ 
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = {"group_id": groupId};
    appendTokenName(data); 
    return apiAction({
        types: ["GET_SETTINGS_ID_REQUESTED", "GET_SETTINGS_ID_SUCCESS", "GET_SETTINGS_ID_FAILED"],
        method: "POST",
        path: "admin/get_settings_group",
        body: data
    });
}

export function addSettingsGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};
    postData.target_setting = {"group_setting_id": data.groupSettingId, "value" : data.value};
    appendTokenName(postData); 
    return apiAction({
        types: ["ADD_SETTINGS_GROUPS_REQUESTED", "ADD_SETTINGS_GROUPS_SUCCESS", "ADD_SETTINGS_GROUPS_FAILED"],
        method: "POST",
        path: "admin/add_settings_group",
        body: postData
    });
}

export function updateSettingsGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};
    postData.target_setting = {"group_setting_id": data.groupSettingId, "value" : data.value};
    appendTokenName(postData);
    return apiAction({
        types: ["UPDATE_SETTINGS_GROUPS_REQUESTED", "UPDATE_SETTINGS_GROUPS_SUCCESS", "UPDATE_SETTINGS_GROUPS_FAILED"],
        method: "POST",
        path: "admin/update_settings_group",
        body: postData
    });
}


export function removeSettingsGroup(groupSettingId){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.group_setting_id = groupSettingId;
    appendTokenName(data); 
    return apiAction({
        types: ["REMOVE_SETTINGS_GROUPS_REQUESTED", "REMOVE_SETTINGS_GROUPS_SUCCESS", "REMOVE_SETTINGS_GROUPS_FAILED"],
        method: "POST",
        path: "admin/remove_settings_group",
        body: data
    });
}

export function getImagesGroup(groupId){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let data = {};
    data.target_group = {"group_id": groupId};
    appendTokenName(data); 
    return apiAction({
        types: ["GET_IMAGES_GROUPS_REQUESTED", "GET_IMAGES_GROUPS_SUCCESS", "GET_IMAGES_GROUPS_FAILED"],
        method: "POST",
        path: "admin/get_images_group",
        body: data
    });
}

export function addImagesGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};
    postData.target_image = {"image_id": data.imageId};
    appendTokenName(postData); 
    return apiAction({
        types: ["ADD_IMAGES_GROUPS_REQUESTED", "ADD_IMAGES_GROUPS_SUCCESS", "ADD_IMAGES_GROUPS_FAILED"],
        method: "POST",
        path: "admin/add_images_group",
        body: postData
    });
}

export function removeImagesGroup(data){
    if (window.disableAPIActiveState == undefined || window.disableAPIActiveState == 0) { localStorage.setItem("unActiveStateSec", new Date().getTime()); }
    let postData = {};
    postData.target_group = {"group_id": data.groupId};
    postData.target_image = {"image_id": data.imageId};
    appendTokenName(postData); 
    return apiAction({
        types: ["Remove_IMAGES_GROUPS_REQUESTED", "REMOVE_IMAGES_GROUPS_SUCCESS", "REMOVE_IMAGES_GROUPS_FAILED"],
        method: "POST",
        path: "admin/remove_images_group",
        body: postData
    });
}



// WEBPACK FOOTER //
// ./src/actions/actionGroup.js